var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 236,
    viewBox: "0 0 225 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 224,
    height: 235,
    rx: 5.5,
    fill: "#D8D8D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 224,
    height: 235,
    rx: 5.5,
    fill: "#EAEAEA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 224,
    height: 235,
    rx: 5.5,
    stroke: "#8E8E8E",
    strokeDasharray: "10 10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113 118C121.288 118 129.237 114.708 135.097 108.847C140.958 102.987 144.25 95.038 144.25 86.75C144.25 78.462 140.958 70.5134 135.097 64.6529C129.237 58.7924 121.288 55.5 113 55.5C104.712 55.5 96.7634 58.7924 90.9029 64.6529C85.0424 70.5134 81.75 78.462 81.75 86.75C81.75 95.038 85.0424 102.987 90.9029 108.847C96.7634 114.708 104.712 118 113 118ZM113 133.625C81.6875 133.625 56.1875 154.625 56.1875 180.5C56.1875 182.25 57.5625 183.625 59.3125 183.625H166.688C168.438 183.625 169.813 182.25 169.813 180.5C169.813 154.625 144.313 133.625 113 133.625Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPl);
export default __webpack_public_path__ + "static/media/user_pl.c8e5222d5b7b8594b4b0e6d405e2e3a5.svg";
export { ForwardRef as ReactComponent };